var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWicp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3584 6.00049C11.6284 6.00049 10.8327 6.37456 9.99156 7.11137C9.59255 7.46051 9.24795 7.83458 8.9895 8.13384C8.9895 8.13384 8.9895 8.13384 8.99177 8.13611V8.13384C8.99177 8.13384 9.39985 8.57819 9.851 9.05429C10.0936 8.76636 10.4427 8.37415 10.844 8.02048C11.5921 7.36529 12.0796 7.22699 12.3584 7.22699C13.4081 7.22699 14.2605 8.05902 14.2605 9.08149C14.2605 10.0972 13.4058 10.9292 12.3584 10.936C12.3108 10.936 12.2496 10.9292 12.1725 10.9133C12.4786 11.0448 12.8073 11.14 13.1202 11.14C15.0427 11.14 15.419 9.88631 15.444 9.79563C15.5006 9.56665 15.5301 9.32634 15.5301 9.07922C15.5301 7.38343 14.1064 6.00049 12.3584 6.00049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64288 12.1669C6.37289 12.1669 7.16864 11.7928 8.00974 11.056C8.40875 10.7069 8.75335 10.3328 9.0118 10.0335C9.0118 10.0335 9.0118 10.0335 9.00954 10.0313V10.0335C9.00954 10.0335 8.60146 9.58918 8.1503 9.11308C7.90772 9.40101 7.55859 9.79322 7.15731 10.1469C6.40916 10.8021 5.92173 10.9404 5.64288 10.9404C4.59321 10.9404 3.74077 10.1083 3.74077 9.08588C3.74077 8.07021 4.59547 7.23818 5.64288 7.23138C5.69049 7.23138 5.7517 7.23818 5.82878 7.25405C5.52272 7.12256 5.19399 7.02734 4.88113 7.02734C2.95862 7.02734 2.58228 8.28106 2.55734 8.37174C2.50066 8.60072 2.47119 8.84103 2.47119 9.08815C2.47119 10.7839 3.89494 12.1669 5.64288 12.1669Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.116 11.1135C12.1321 11.0885 11.1096 10.3132 10.9011 10.1205C10.3615 9.62173 9.11686 8.27279 9.01937 8.16624C8.10799 7.14604 6.87242 6.00342 5.64364 6.00342H5.64138H5.63911C4.14735 6.01022 2.89137 7.02135 2.55811 8.37028C2.58304 8.28186 3.07501 7.00321 4.87963 7.04856C5.86355 7.07349 6.89055 7.86018 7.10139 8.05288C7.64097 8.55165 8.88561 9.90058 8.9831 10.0071C9.89447 11.0273 11.13 12.17 12.3588 12.17H12.3611H12.3634C13.8551 12.1632 15.1111 11.152 15.4444 9.80309C15.4172 9.88924 14.9229 11.1566 13.116 11.1135Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWicp);
export default __webpack_public_path__ + "static/media/wicp.b7488d52d2d03e18da42af9fec79d670.svg";
export { ForwardRef as ReactComponent };